export { AnonymousPeersFigure } from "./AnonymousPeersFigure";
export { OttFigure } from "./OttFigure";
export { PushFigure } from "./PushFigure";
export { WeatherFigure } from "./WeatherFigure";
export { XrFigure } from "./XrFigure";
export type { ResearchFigureProps } from "./types";

import type { ComponentType } from "react";

import { AnonymousPeersFigure } from "./AnonymousPeersFigure";
import { OttFigure } from "./OttFigure";
import { PushFigure } from "./PushFigure";
import type { ResearchFigureProps } from "./types";
import { WeatherFigure } from "./WeatherFigure";
import { XrFigure } from "./XrFigure";

export const researchFigureRegistry = {
  weather: WeatherFigure,
  push: PushFigure,
  peers: AnonymousPeersFigure,
  ott: OttFigure,
  xr: XrFigure,
} satisfies Record<string, ComponentType<ResearchFigureProps>>;

export type ResearchFigureKey = keyof typeof researchFigureRegistry;
